// extracted by mini-css-extract-plugin
export default {"modalBody":"details_modalBody__vyllO","largeImg":"details_largeImg__R8Frx","details":"details_details__8DnYF"};